export const licensesStrings = {
  english: {
    title: 'MY ORDER LICENSE KEYS',
    key: 'License Key',
    devices: 'Devices used:',
    status: 'Entitlement Status',
    action: 'Action',
    enabled: 'Enabled',
    unlink: 'Unlink devices',
    download: 'Downloads',
  },

  japan: {
    title: '購入したライセンスキー',
    key: 'ライセンスキー',
    devices: '使用中のデバイス',
    status: 'サービス使用ステータス',
    action: 'アクション',
    enabled: 'アクティブ',
    unlink: 'デバイスのリンクを解除する',
    download: 'ダウンロード済みのアイテム',
  },
};
